import React from 'react';
import { useTranslation } from 'react-i18next';
import { Theme as AugmentedTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { Box, Typography } from 'web-library';
import { WithdrawalReason } from '../../api/candidate/exam/model';

const useStyles = makeStyles()((theme) =>
({
  marginBottom: {
    marginBottom: theme.spacing(3),
  },
  inputLabel: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
  },
  underlineWord: {
    textDecoration: 'underline',
    marginLeft: theme.spacing(0.75),
  },
}));

const WithdrawalReasonDocumentInfo = ({ selectedArr }: { selectedArr: WithdrawalReason }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <>
      {selectedArr.reasonDescription === 'Others' ? (
        <Typography className={classes.marginBottom} variant="h3">
          {t('withdrawal->>WithdrawalReason.UploadSupportingDocumentsOptional')}
        </Typography>
      ) : (
        <>
          <Typography className={classes.marginBottom} variant="h3">
            {t('withdrawal->>WithdrawalReason.UploadSupportingDocuments')}
          </Typography>

          <Typography className={classes.inputLabel} variant="h5">
            {t('withdrawal->>WithdrawalReason.SupportingDocumentRequired')}
          </Typography>
        </>
      )}
      <Box className={classes.marginBottom}>
        {selectedArr.requiredDocumentInfo.map((requiredDocument: string) => (
          <Box display="flex" key={requiredDocument}>
            <Typography>{requiredDocument}</Typography>
            {requiredDocument === 'NS Enlistment Letter' && (
              <Typography className={classes.underlineWord} variant="h5">
                {t('withdrawal->>WithdrawalReason.BoldWord')}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
       <Typography className={classes.inputLabel} variant="body2">
         {t('withdrawal->>WithdrawalReason.uploadInstruction')}
       </Typography>
    </>

  );
};

export default WithdrawalReasonDocumentInfo;
